/*
 * Version of StatementLines specific to reseller
 */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Hidden, Grid, Link, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import AppLogo from '../ui/AppLogo';
import AbEnvironment from '../auth/AbEnvironment';
import { format } from 'date-fns';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
      // [theme.breakpoints.up('xs')]: {
      //  padding: theme.spacing(1),
      // },
      // [theme.breakpoints.up('sm')]: {
      //   padding: theme.spacing(2),
      // },
      // [theme.breakpoints.up('md')]: {
      //   padding: theme.spacing(3),
      // },
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 24,
    },
    tblCellPositive: {
      textAlign: 'right',
      color: '#006400'
    },
    tblCellNegative: {
      textAlign: 'right',
      color: 'red'
    },
    tblCellError: {
      textAlign: 'right',
      color: '#006400',
      textDecoration: 'line-through'
    },
    linkitalic: {
      fontStyle: 'italic',
    },
});

class ResellerStatementLines extends React.Component {
  
  renderWhoTableCell= (accountId, accountName, classes, customerTransferred) => {

    if (!accountName) {
      return '';
    }
    if (customerTransferred) {

      //provide a link to account if not same as user account.
      if (accountId !== abEnvironment.getUserAttribute('a_id')) {

        let aUrl = "customer?accountId=" + accountId + "&fp=Statements";

        if (classes != null) {
          return (
            <Tooltip title="Customer is transferred">
              <Link component="button" 
                    variant="body2"
                    className={classes.linkitalic}
                    onClick={this.goToCustomer.bind(this, aUrl, "0")}>
                {accountName}
              </Link>
            </Tooltip>
          );
        } else {
          return (
            <Tooltip title="Customer is transferred">
              <Link component="button" 
                    variant="body2"
                    onClick={this.goToCustomer.bind(this, aUrl, "0")}>
                {accountName}
              </Link>
            </Tooltip>
          );
        }
      } else {
        return accountName;
      }


    } else {

      //provide a link to account if not same as user account.
      if (accountId !== abEnvironment.getUserAttribute('a_id')) {

        let aUrl = "customer?accountId=" + accountId + "&fp=Statements";

        if (classes != null) {
          return (
            <Link component="button" 
                  variant="body2"
                  className={classes.linkitalic}
                  onClick={this.goToCustomer.bind(this, aUrl, "0")}>
              {accountName}
            </Link>
          );
        } else {
          return (
            <Link component="button" 
                  variant="body2"
                  onClick={this.goToCustomer.bind(this, aUrl, "0")}>
              {accountName}
            </Link>
          );
        }
      } else {
        return accountName;
      }


    }


  }

  renderAppLinkTableCell= (appId, appName, appSku, customerTransferred) => {

    if (!appName) {
      return '';
    }

    let aUrl = "app?appId=" + appId + "&fp=Statements";

    if (customerTransferred) {
      return (
       <Typography variant="body2">{appName + appSku}</Typography>
      );
    }

    if (appSku != null && appSku !== '' && appSku !== appName) {
      return (
        <React.Fragment>
          <Link component="button" 
                variant="body2"
                onClick={this.goTo.bind(this, aUrl)}>
            {appName}
          </Link>
        <Typography variant="body2">{appSku}</Typography>
       </React.Fragment>
      );
    } else {
      return (
        <Link component="button" 
              variant="body2"
              onClick={this.goTo.bind(this, aUrl)}>
          {appName}
        </Link>
      );
    }
  }

  renderPaymentSourceTableCell= (accountId, paymentSource) => {

    if (!paymentSource) {
      return '';
    }

    //provide a link to account if not same as user account.
    if (accountId !== abEnvironment.getUserAttribute('a_id')) {

      if (paymentSource === 'Balance') {
        return (
          <i>{paymentSource}</i>       
        );
      }

      let aUrl = "customer?accountId=" + accountId + "&fp=Statements";

      return (
        <Link component="button" 
              variant="body2"
              onClick={this.goToCustomer.bind(this, aUrl, "1")}>
          <i>{paymentSource}</i>
        </Link>
      );

    } else {
      return paymentSource;
    }

  }


  goToCustomer(route, tabValue) {
    localStorage.setItem('customerTabVal', tabValue);

    this.props.history.push(`/${route}`);
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.cl.nodes;

    let noRowsToShow = false;
    if (thenodes.length === 1 && thenodes[0].transactionTime == null) {
      noRowsToShow = true;
    }

    return (
      <div className={classes.paper}>
        <TableContainer>
          <Table>
            <TableHead className={classes.tblHead}>
              <TableRow className={classes.tblHeadRow}>
                <TableCell>Date</TableCell> 
                <TableCell><Tooltip title='Who is this line related to'><div>Who</div></Tooltip></TableCell>
                <TableCell colSpan={2}>Item</TableCell>
                <TableCell align="right"><Tooltip title='App subscription cost'><div>Cost</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='Income from customers for services and markup on subscriptions, and incentives and refunds from vendors.'><div>Revenue</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='AppBind fee'><div>AppBind</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='Payment processing (credit card) fee.'><div>CC</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='Payment into AppBind for subscription, services, and fees'><div>Payment</div></Tooltip></TableCell>
                <TableCell><Tooltip title='Funding source used for payment / payout'><div>Funding</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='Payout to you of funds collected on your behalf'><div>Payout</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='Current balance of your funds in AppBind'><div>Balance</div></Tooltip></TableCell>
              </TableRow>
            </TableHead>
            { noRowsToShow === false &&
            <TableBody>
              { thenodes.map( (n,index) => {
                let tdate = format(new Date(n.transactionTime), 'yyyy-MM-dd');
                let tType = n.transactionType;
                let psSource = null;
                let psInAmt = null;
                let psOutAmt = null;
                let psNetworkFee = null;
                let appName = null;
                let appSku = null;
                let bindCardCharge = null;
                let transfer = null;
                let transferOut = false;
                let refundAmount = null;
                let markup = null;
                let appbindFee = null;
                let balance = null;
                let customerTransferred = false;
                if (n.customerStatus === 2) {
                  customerTransferred = true;
                }

                let paymentStatus = 1;  // Only relevant to payment transactions, default to 1 (confirmed)
                let paymentStatusReason = null;
                let topupMessage = 'Top-up funding';
                let paidByBalance = false;
                let customerPay = false; // Flag for ui
                let bindcardChargeClass = classes.tblCellNegative;
                let refundClass         = classes.tblCellPositive;
                let markupClass         = classes.tblCellPositive;
                let appbindFeeClass     = classes.tblCellNegative;
                let psNetworkFeeClass   = classes.tblCellNegative;
                let psOutAmtClass       = classes.tblCellPositive;
                let psInAmtClass        = classes.tblCellNegative;
                // let refund = false;

                let markupTooltip = '';
                let payoutPendingTooltip = null;

                if (n.paidByBalance === 1) {
                  paidByBalance = true;
                }

                // Use transaction type to determine what to show.
                if (tType === -1) { // Pending bindcard charge
                  bindCardCharge = '(' + Number(n.bindCardCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';

                  appName = n.appName;
                } else if (tType === 0 || tType === 99 || tType === 32) { // Bindcard charge
                  if (n.bindCardCharge < 0) {
                    bindCardCharge = Number(n.bindCardCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                  } else if (n.bindCardCharge > 0) {
                    bindCardCharge = '(' + Number(n.bindCardCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  } else {
                    bindCardCharge = '';
                  }

                  // If the customer is paying, we want the ui it put the cost in italics to signal that it doesn't impact the reseller balance.
                  // There is a workaround to pass an amount in on psInAmt if the customer is paying.  So check this.
                  if (n.psInAmt != null && n.psInAmt === n.bindCardCharge && n.accountId !== abEnvironment.getUserAttribute('a_id')) {
                    customerPay = true;
                  }

                  // Markup should be blank if this is provisioner buying for self and markup is 0.
                  if (n.accountId === abEnvironment.getUserAttribute('a_id') && (n.markup == null || n.markup === 0)) {
                    markup = '';
                  } else {
                    markupTooltip = '';

                    let tmarkup = Number(n.markup);

                    if (tmarkup > 0) {
                      if (tType === 99) {
                        markupTooltip = Number(tmarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ' service charge';
                      } else {
                        markupTooltip = Number(tmarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ' markup';
                      }
                     
                    } else if (tmarkup < 0) {
                      markupTooltip = Number(tmarkup * -1).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ' discount';
                    }

                    if (n.passThroughFee != null) {
                      tmarkup = tmarkup + Number(n.passThroughFee);
                      if (markupTooltip !== '') {
                        markupTooltip = markupTooltip + ' + ' + Number(n.passThroughFee).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})  + ' pass through fee';
                      } else {
                        markupTooltip = Number(n.passThroughFee).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})  + ' pass through fee';
                      }
                    }

                    if (n.wholesaleMarkup != null && tType !== 99) {
                      tmarkup = tmarkup + Number(n.wholesaleMarkup);
                      if (markupTooltip !== '') {
                        markupTooltip = markupTooltip + ' + ' + Number(n.wholesaleMarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})  + ' wholesale markup';
                      } else {
                        markupTooltip = Number(n.wholesaleMarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})   + ' wholesale markup';
                      }
                    }

                    markup = Number(tmarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                    if (tmarkup < 0) {
                      markup = Number(tmarkup * -1).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                      markup = '(' + markup + ')';
                      markupClass = classes.tblCellNegative;
                    }
                  }

                  // Using != 0 instead of !== 0 because we want to compare with "zeroish"
                  if (n.appbindFee != null && n.appbindFee != 0) {
                    appbindFee = '(' + Number(n.appbindFee).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  }

                  appName = n.appName;
                  appSku = n.appSku;
                  //These are appbind plan charges
                  if (tType === 32) {
                    appName = 'AppBind ' + n.appName ;
                    appSku = '';
                  }

                } else if (tType === 25) { // wallet transfer
                  if (n.psInAmt) {
                    transfer = Number(n.psInAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                    transferOut = false;
                  } else {
                    transfer = "(" + Number(-1 * n.psOutAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ")"; 
                    transferOut = true;

                  }
                } else if (tType === 1 || tType === 3 || tType === 8 || tType === 10 || tType === 31 || tType === 33) { // Funding source charge. 1 is normal, 3 is dunning, 8 is topup, 10 is delayed failure, 33 is a plan payment
                  paymentStatus = n.paymentStatus;

                  if (n.psType == null) {
                    psSource = 'Balance';
                  } else if (n.psCcBrand != null) {
                    psSource = 'CC ***' + n.psCcLast4;
                  } else {
                    // psSource = 'ACH ***' + n.psAchAccountNum;
                    psSource = 'ACH';
                  }

                  /*
                  if (tType === 3) {
                    markup = Number(n.psOutAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                  } else {
                    if (n.passThroughFee != null) {
                      markup = Number(n.passThroughFee).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                    }
                  }
                  */
                 
                  if (n.passThroughFee != null) {
                    markup = Number(n.passThroughFee).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                  }

                  psOutAmt = Number(n.psOutAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

                  let ttlFee = Number(n.psCFee) + Number(n.psRFee);
                  if (ttlFee === 0) {
                    psNetworkFee = '';
                  } else {
                    psNetworkFee = '(' + Number(ttlFee).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  }

                  // If the failure was immediate, indicate that there was a failure
                  if (tType !== 10 && paymentStatus === -1) {
                    ttlFee = '';
                    psNetworkFee = '';
                    topupMessage = 'Top-up failure';
                    psOutAmtClass = classes.tblCellError;

                    // Lookup payment status reason if available
                    if (n.paymentStatusReason != null) {
                      paymentStatusReason = abEnvironment.getDeclineTranslation(n.paymentStatusReason);
                      if (paymentStatusReason === '') {
                        paymentStatusReason = null;
                      }
                    }
                  }

                  // If the failure was delayed, indicate that this payment is reversed later
                  if (tType !== 10 && paymentStatus === -2) {
                    // topupMessage = 'Top-up funding (reversed below)';
                    paymentStatusReason = 'This payment was initially accepted, but failed - see reversal below';
                  }

                  // Delayed
                  if (tType === 10) {
                    topupMessage = 'Payment failure';
                    psOutAmtClass = classes.tblCellError;

                    // Lookup payment status reason if available
                    if (n.paymentStatusReason != null) {
                      paymentStatusReason = abEnvironment.getDeclineTranslation(n.paymentStatusReason);
                      if (paymentStatusReason === '') {
                        paymentStatusReason = null;
                      }
                    }
                  }
                } else if (tType === 4 || tType === 11) { // Payout
                  if (n.psCcBrand != null) {
                    psSource = 'CC ***' + n.psCcLast4;
                  } else {
                    // psSource = 'ACH ***' + n.psAchAccountNum;
                    psSource = 'ACH';
                  }

                  if (tType === 11 && n.psRFee != null && Number(n.psRFee) > 0) {
                    psNetworkFee = '(' + Number(n.psRFee).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                    if (n.appLogo === 'Transferring') {
                      payoutPendingTooltip = 'Payout pending';
                    }
                  } else {
                    psNetworkFee = '';
                  }

                  psInAmt = '(' + Number(n.psInAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';

                  //Adding "if payment status = 0, is pending"; this is the field modified to reflect this...
                  if (tType === 11 && n.paymentStatus === 0) {
                    payoutPendingTooltip = 'Payout pending';
                  } 
                } else if (tType === 6) {
                  appName = n.appName;
                  appSku = n.appSku;
                  // refund = true;

                  // If the customer paid, the refund is to the customer, and we want the ui it put the cost in italics to signal that it doesn't impact the reseller balance.
                  // There is a workaround to pass an amount in on psInAmt if the customer is paying.  So check this.
                  if (n.psInAmt != null && n.psInAmt === n.bindCardCharge && n.accountId !== abEnvironment.getUserAttribute('a_id')) {
                    customerPay = true;
                  }

                  // There are two components to the refund.  The bindCardCharge holds the refund from the vendor,
                  // and the markup holds the refund from the reseller
                  refundAmount = Number(n.bindCardCharge * -1).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

                  if (n.markup != null && n.markup < 0) {
                    markupClass = classes.tblCellNegative;
                    let tmarkup = Number(n.markup) * -1;
                    markupTooltip = 'Markup fees refunded to your customer.';
                    markup = '(' + Number(tmarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  }
                } else if (tType === 15) {
                  appbindFee = Number(n.markup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                  appbindFeeClass = classes.tblCellPositive;
                } else if (tType === 16) {
                  markupClass = classes.tblCellNegative;
                  let tmarkup = Number(n.markup) * -1;
                  appbindFee = '(' + Number(tmarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  appbindFeeClass = classes.tblCellNegative;
                } else if (tType === 21 || tType === 23) {
                  if (tType === 21) {
                    markupTooltip = 'Vendor rebate';
                  } else {
                    markupTooltip = 'Vendor rebate reversal';
                  }
                  markup = Number(n.markup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                  if (n.markup < 0) {
                    markup = '(' + Number(n.markup * -1).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                    markupClass = classes.tblCellNegative;
                  }
                }

                // Balance is on all
                if (n.balance < 0) {
                  let negBalance = -1 * Number(n.balance);
                  balance = '(' + Number(negBalance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                } else {
                  balance = Number(n.balance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                }

                // transactionId can be on multiple rows; in order to avoid the "key" duplication warning, append key with index.
                let rowKey = n.transactionId + '_' + index;

                /* Transaction date column */
                let dateElement = 
                  tType === -1 ? (<i>{tdate}</i>) :
                  tType >= 0 ? (<>{tdate}</>) :
                  '';

                /* Who is the transaction related to */
                let whoElement = '';
                if (tType === -1) {
                  whoElement = this.renderWhoTableCell(n.accountId, n.accountName, classes, customerTransferred);
                } else if (tType === 15 || tType === 16) {
                  whoElement = (
                    <Grid container alignItems="center" wrap="nowrap" spacing={1}>
                      <Grid item><AppLogo logoPath="/logos/appbind-128t.png" appName="AppBind" imageHeight='24px'/></Grid>
                      <Grid item>
                        AppBind
                      </Grid>
                    </Grid>
                  );
                } else if (tType === 21 || tType === 23) {
                  whoElement = (
                    <Grid container alignItems="center" wrap="nowrap" spacing={1}>
                      <Grid item><AppLogo logoPath={n.appLogo} appName={n.accountName} imageHeight='24px'/></Grid>
                      <Grid item>
                        {n.accountName}
                      </Grid>
                    </Grid>
                  );
                } else if (tType >= 0) {
                  whoElement = this.renderWhoTableCell(n.accountId, n.accountName, null, customerTransferred);
                }

                /* "Item" column */
                

                return (
                  <TableRow key={rowKey}>
                    <TableCell style={{whiteSpace: 'nowrap'}}>{dateElement}</TableCell>
                    <TableCell style={{whiteSpace: 'nowrap'}}>{whoElement}</TableCell>

                    {/* Pending transaction - App logo and name */}
                    { tType === -1 &&
                    <TableCell colSpan={2}>
                      <Grid container alignItems="center" wrap="nowrap" spacing={1}>
                        <Hidden lgDown>
                          <Grid item><AppLogo logoPath={n.appLogo} appName={n.appName} imageHeight='24px'/></Grid>
                          {appName != null &&
                          <Grid item>
                            <Typography variant="subtitle2"><i>{this.renderAppLinkTableCell(n.appId, appName, appSku)}</i></Typography>
                          </Grid>
                          }
                        </Hidden>
                        <Hidden lgUp>
                          <Grid item>
                            <AppLogo logoPath={n.appLogo} appName={n.appName} imageHeight='24px' theTooltip={n.appName}/>
                          </Grid>
                        </Hidden>
                      </Grid>
                    </TableCell>
                    }

                    {/* Bindcard charge or refund - app logo and name */}
                    { (tType === 0 || tType === 99 || tType === 6) &&
                    <TableCell colSpan={2}>
                      <Grid container alignItems="center" wrap="nowrap" spacing={1}>
                        <Hidden lgDown>
                        <Grid item><AppLogo logoPath={n.appLogo} appName={n.appName} imageHeight='24px'/></Grid>
                          {appName != null &&
                          <Grid item className={classes.appnameitem}>
                            <Typography variant="subtitle2">{this.renderAppLinkTableCell(n.appId, appName, appSku, customerTransferred)}</Typography>
                          </Grid>
                          }
                        </Hidden>
                        <Hidden lgUp>
                          <Grid item>
                            <AppLogo logoPath={n.appLogo} appName={n.appName} imageHeight='24px' theTooltip={n.appName}/>
                          </Grid>
                        </Hidden>
                      </Grid>
                    </TableCell>
                    }
                    {/* AppBind plan charge  */}
                    { (tType === 32) &&
                    <TableCell colSpan={2}>
                      <Grid container alignItems="center" wrap="nowrap" spacing={1}>                        
                          <Grid item >
                            <Typography variant="body2">{appName}</Typography>
                          </Grid>
                      </Grid>
                    </TableCell>
                    }
                    {/* could replace "item" column conditional view with select to fill the cell contents for all with just Typography */}
                    { tType === 1 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Subscription payment</Typography>
                    </TableCell>}
                    { tType === 31 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Services payment</Typography>
                    </TableCell>}
                    { tType === 33 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">AppBind plan payment</Typography>
                    </TableCell>}
                    { tType === 25 && transferOut &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Transfer to account</Typography>
                    </TableCell>}
                    { tType === 25 && !transferOut &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Transfer from account</Typography>
                    </TableCell>}

                    { tType === 3 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Dunning payment</Typography>
                    </TableCell>}
                    {/* Payouts */}
                    { (tType === 4 || tType === 11) &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Payout</Typography>
                    </TableCell>}
                    {/* Topup transaction - indicate */}
                    { tType === 8 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">{topupMessage}</Typography>
                    </TableCell>}
                    {/* Delayed payment failure transaction - indicate */}
                    { tType === 10 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">{topupMessage}</Typography>
                    </TableCell>}
                    { (tType === 15 || tType === 16) &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">
                        {n.paymentStatusReason ? n.paymentStatusReason :
                        tType === 15 ? 'Account Credit' :
                        tType === 16 ? 'Account Debit' :
                        ''}
                      </Typography>
                    </TableCell>}
                    { tType === 21 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Rebate</Typography>
                    </TableCell>}
                    { tType === 23 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Rebate reversal</Typography>
                    </TableCell>}
                    {/* Other transactions - skip app logo and name */}
                    { tType > 0 && ![1,3,4,6,8,10,11,15,16,21,23,25,31,32,33,99].includes(tType) &&
                    <TableCell colSpan={2}/>}

                    {/* Bindcard charge column */}
                    { tType === -1 &&
                    <TableCell align="right"><i>{bindCardCharge}</i></TableCell>}
                    { tType >= 0 && tType !== 25 && tType !== 6 && !customerPay && !paidByBalance &&
                    <TableCell className={bindcardChargeClass}>{bindCardCharge}</TableCell>}
                    { tType >= 0  && tType !== 25 && tType !== 6 && !customerPay && paidByBalance &&
                    <TableCell className={bindcardChargeClass} align="right"><Tooltip title='This app subscription was paid for with your account balance'><div>{bindCardCharge}</div></Tooltip></TableCell>}
                    { tType >= 0  && tType !== 25 && tType !== 6 && tType !== 99 && customerPay &&
                    <TableCell align="right"><Tooltip title='This app subscription was billed directly to your customer and does not impact your balance'><div><i>{bindCardCharge}</i></div></Tooltip></TableCell>}
                    { tType >= 0 && tType === 99 && customerPay &&
                    <TableCell align="right"><div>{bindCardCharge}</div></TableCell>}
                    { tType >= 0 && tType === 25 &&
                    <TableCell align="right">{transfer}</TableCell>}

                    { tType === 6 && !customerPay &&
                    <TableCell  className={refundClass}><Tooltip title={'You received a refund from ' + n.appName + ' on ' + tdate + '.'}><div>{refundAmount}</div></Tooltip></TableCell>}
                    { tType === 6 && customerPay &&
                    <TableCell align="right" className={refundClass}><Tooltip title={'Your customer received a refund from  ' + n.appName + ' on ' + tdate + '. This refund does not impact your balance.'}><div><i>{refundAmount}</i></div></Tooltip></TableCell>}

                    { tType === -1 &&
                    <TableCell align="right"><i>Pending</i></TableCell>}
                    { tType === 1 &&
                    <TableCell className={markupClass}>{markup}</TableCell>}
                    { tType >= 0 && tType !== 6 && tType !== 1 &&
                    <TableCell className={markupClass}><Tooltip placement='right' title={markupTooltip}><div>{markup}</div></Tooltip></TableCell>}
                    { tType === 6 &&
                    <TableCell className={markupClass}><Tooltip title={markupTooltip}><div>{markup}</div></Tooltip></TableCell>}

                    <TableCell className={appbindFeeClass}>{appbindFee}</TableCell>
                    <TableCell className={psNetworkFeeClass}>{psNetworkFee}</TableCell>

                    { n.accountId === abEnvironment.getUserAttribute('a_id') && !n.backupPayment && paymentStatusReason == null &&
                    <TableCell className={psOutAmtClass}>{psOutAmt}</TableCell>}
                    { n.accountId === abEnvironment.getUserAttribute('a_id') && !n.backupPayment && paymentStatusReason != null &&
                    <TableCell className={psOutAmtClass}><Tooltip title={paymentStatusReason}><div>{psOutAmt}</div></Tooltip></TableCell>}
                    { n.accountId === abEnvironment.getUserAttribute('a_id') && n.backupPayment === 1 &&
                    <TableCell className={psOutAmtClass}><Tooltip title='This payment was made due to backing up customer funding'><div><i>{psOutAmt}</i></div></Tooltip></TableCell>}
                    { n.accountId === abEnvironment.getUserAttribute('a_id') && n.backupPayment === 2 &&
                    <TableCell className={psOutAmtClass}><Tooltip title='This payment was made due to backing up customer funding and was recovered from your customer'><div><i>{psOutAmt}</i></div></Tooltip></TableCell>}
                    { n.accountId !== abEnvironment.getUserAttribute('a_id') && n.transactionType !== 3 && n.paymentStatus === -1 &&
                    <TableCell className={psOutAmtClass}><Tooltip title='Your customer was billed directly, but there was a failure in charging their payment source.'><div><i>{psOutAmt}</i></div></Tooltip></TableCell>}
                    { n.accountId !== abEnvironment.getUserAttribute('a_id') && n.transactionType !== 3 && n.paymentStatus !== -1 &&
                    <TableCell align="right"><Tooltip title='This payment was received directly from your customer and does not impact your balance'><div><i>{psOutAmt}</i></div></Tooltip></TableCell>}
                    { n.accountId !== abEnvironment.getUserAttribute('a_id') && n.transactionType === 3 && n.paymentStatus === -1 &&
                    <TableCell className={psOutAmtClass}><Tooltip title='We attempted to recover (dunn) a failed payment from your customer, but there was another failure in charging their payment source.'><div><i>{psOutAmt}</i></div></Tooltip></TableCell>}
                    { n.accountId !== abEnvironment.getUserAttribute('a_id') && n.transactionType === 3 && n.paymentStatus !== -1 &&
                    <TableCell align="right"><Tooltip title='This payment was dunned from your customer and does not impact your balance'><div><i>{psOutAmt}</i></div></Tooltip></TableCell>}

                    <TableCell style={{whiteSpace: 'nowrap'}}>{this.renderPaymentSourceTableCell(n.accountId, psSource)}</TableCell>

                    { tType === 11 && payoutPendingTooltip != null &&
                    <TableCell className={psInAmtClass}><Tooltip placement='right' title={payoutPendingTooltip}><div><i>{psInAmt}</i></div></Tooltip></TableCell>}
                    { tType === 11 && payoutPendingTooltip == null &&
                    <TableCell className={psInAmtClass}><Tooltip placement='right' title='This amount was paid out to your connected payout source'><div>{psInAmt}</div></Tooltip></TableCell>}
                    { tType !== 11 &&
                    <TableCell/>}

                    <TableCell align="right">{balance}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody> }
          </Table>
        </TableContainer>
      </div>
    );

  } // end render()
}

ResellerStatementLines.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(ResellerStatementLines);
